import { render } from "./InfoFrete.vue?vue&type=template&id=488146c0&scoped=true"
import script from "./InfoFrete.vue?vue&type=script&lang=js"
export * from "./InfoFrete.vue?vue&type=script&lang=js"

import "./InfoFrete.vue?vue&type=style&index=0&id=488146c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488146c0"]])

export default __exports__